import classNames from 'classnames';
import { useState } from 'react';

import styles from './FormToggle.module.scss';
import { FormToggleProps } from './types';

export function FormToggle({
  name,
  id,
  value = '',
  type = 'checkbox',
  checked = false,
  isError,
  readonly,
  required,
  onChange,
}: FormToggleProps) {
  const [isFocus, setIsFocus] = useState(false);

  return (
    <label className={styles.label}>
      <input
        id={id}
        name={name}
        required={required}
        readOnly={readonly}
        className={styles.input}
        type={type}
        value={value}
        checked={checked}
        onChange={onChange}
        onFocus={() => setIsFocus(true)}
        onBlur={() => setIsFocus(false)}
      />
      <div
        className={classNames(styles.toggle, styles[type], {
          [styles.isError]: isError,
          [styles.isFocus]: isFocus,
          [styles.isChecked]: checked,
        })}
      />
    </label>
  );
}
